<template>
  <div class="container reinscription">
    <Introduction />

    <div class="card carte-reinscription">
      <div class="card-body">
        <div class="num_rechargement">
          <p class="label-rechargement">Indiquez le nom de famille et le prénom de votre enfant</p>
        </div>

        <div class="div_icon_input">
          <i class="fas fa-user-graduate fa-2x"></i>
          <input
            v-model="nomEnfant"
            class="input_number form-control"
            type="text"
            placeholder="Nom"
            required
          />
        </div>

        <div class="div_icon_input">
          <i class="fas fa-user-graduate fa-2x"></i>
          <input
            v-model="prenomEnfant"
            class="input_number form-control"
            type="text"
            placeholder="Prénom"
          />
        </div>

        <p>Indiquez la date de naissance de votre enfant</p>
        <div class="div_icon_input">
          <i class="fas fa-calendar-alt fa-2x"></i>
          <input
            v-model="dateNaissance"
            class="input_number form-control"
            type="date"
            required
          />
        </div>

        <div class="div_btn_verif">
          <button @click="verifierRechargement" class="btn-verif btn">Vérifier</button>
        </div>
      </div>
    </div>

    <div v-if="loading" class="div_loader">
      <div
        class="spinner-border loader"
        role="status"
        style="width: 3rem; height: 3rem; color: #0fa8bd"
      >
        <span class="visually-hidden">Chargement...</span>
      </div>
    </div>

    <!-- Modal succès -->
    <div v-if="showModalSucces" class="modal-overlay" @click.self="retour">
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-body modal-recap">
            <h1 class="titre-coordonnees-enfant">Votre enfant est bien :</h1>
            <h2 class="coordonnees-enfant">{{ dossierEleve.prenom }} {{ dossierEleve.nom }}</h2>

            <div class="div_twobtns row">
              <div class="col-6">
                <button @click="retour" class="bouton-retour btn btn-lg">NON</button>
              </div>
              <div class="col-6">
                <button @click="accesChoixFormulaire" class="bouton-acces-formulaire btn btn-lg">OUI</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal erreur -->
    <div v-if="showModalErreur" class="modal-overlay" @click.self="retourErreur">
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content modal-content-erreur">
          <div class="modal-body modal-recap">
            <h1 class="titre-coordonnees-enfant">Impossible de retrouver votre enfant</h1>
            <h2 v-if="erreurTitre" class="msg-erreur">
              Le nom de famille, le prénom, ou la date de naissance sont incorrects.<br />
              Veuillez contacter la boutique.
            </h2>
            <div class="div-btn-retour-erreur">
              <button class="btn-retour-erreur" @click="retourErreur">
                <i class="fas fa-times fa-3x"></i>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal choix formulaire -->
    <div v-if="showModalChoixForm" class="modal-overlay" @click.self="showModalChoixForm = false">
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-body modal-recap">
            <h1 class="titre-coordonnees-enfant">Mon enfant entre en :</h1>

            <router-link class="div_btn_cas" :to="{ name: 'reinscription-formulaire-cas-2' }">
              <button class="cas btn">
                <span class="titre" id="cc2t">
                  COLLÈGE OU LYCÉE DE LA COMMUNAUTÉ DE COMMUNES TERRES TOULOISES<br />
                  <span class="description">(de la 6ème à la Terminale)</span>
                </span>
              </button>
            </router-link>

            <router-link class="div_btn_cas" :to="{ name: 'reinscription-formulaire-cas-3' }">
              <button class="cas btn">
                <span class="titre" id="hors_cc2t"
                  >COLLÈGE OU LYCÉE HORS COMMUNAUTE DE COMMUNES TERRES TOULOISES<br />
                  <span class="description">(de la 6ème à la Terminale)</span>
                </span>
              </button>
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import Introduction from '../components/Introduction.vue'

export default {
  name: 'Reinscription',
  components: { Introduction },
  data() {
    return {
      nomEnfant: '',
      prenomEnfant: '',
      dateNaissance: '',
      loading: false,
      dossierEleve: [],
      erreurTitre: false,
      showModalSucces: false,
      showModalErreur: false,
      showModalChoixForm: false,
    }
  },
  methods: {
    verifierRechargement() {
      this.erreurTitre = true
      this.loading = true
      axios
        .get(
          'reinscription/?nom=' +
            this.nomEnfant +
            '&prenom=' +
            this.prenomEnfant +
            '&dateNaissance=' +
            this.dateNaissance,
        )
        .then(succes => {
          this.dossierEleve = succes.data
          this.$store.commit('change', succes.data)
          this.loading = false
          this.showModalSucces = true
        })
        .catch(reason => {
          console.error('ERREUR', reason)
          this.loading = false
          this.showModalErreur = true
        })
    },

    retour() {
      this.showModalSucces = false
    },

    accesChoixFormulaire() {
      this.showModalSucces = false
      this.showModalChoixForm = true
    },

    retourErreur() {
      this.showModalErreur = false
    },
  },
}
</script>

<style scoped lang="scss">
@import '../sass/app';

.carte-reinscription {
  margin-top: 3rem;
  box-shadow: 0 0 20px 0 lightgray;
  border-radius: 10px;

  .card-body {
    padding: 1rem 1rem 2rem 1rem;
  }

  .num_rechargement {
    display: flex;
    @include media-breakpoint-down(xs) {
      display: block;
    }

    .label-rechargement {
      margin-top: auto;
    }
  }

  .div_icon_input {
    margin-bottom: 2.5rem;
    @include icon_form;
    @include media-breakpoint-down(xs) {
      display: block;
    }
  }

  .div_icon_input:focus-within {
    i {
      color: $firstcolor;
    }
  }

  .div_btn_verif {
    display: flex;

    .btn-verif {
      @include boutons;
      font-size: 18px;
      padding: 0.75rem 1rem;
      text-transform: uppercase;
      margin: auto;
      border-color: transparent;
    }

    .btn-verif:hover {
      @include boutons_hover;
    }
  }
}

.modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1050;
}

.modal-content {
  background-color: $white;
  border-radius: 8px;
}

.modal-content-erreur {
  background-color: $white;

  .titre-coordonnees-enfant {
    color: $thirdcolor !important;
  }

  .msg-erreur {
    color: $annexecolor !important;
  }

  .btn-retour-erreur i {
    color: $annexecolor !important;
  }
}

.modal-recap {
  padding: 2rem 1rem;

  .titre-coordonnees-enfant {
    font-family: $titlefont;
    text-align: center;
    color: $thirdcolor;
  }

  .coordonnees-enfant {
    text-align: center;
    color: $firstcolor !important;
    margin: 2rem 0;
  }

  .msg-erreur {
    font-size: 18px;
    font-family: $textfont;
    color: $annexecolor;
    text-align: center;
    margin: 1.5rem 0;
  }

  .div_twobtns {
    .bouton-retour {
      display: block;
      margin: auto;
      background-color: $danger;
      color: white;
    }

    .bouton-acces-formulaire {
      display: block;
      margin: auto;
      background-color: $success;
      color: white;
    }
  }

  .div-btn-retour-erreur {
    display: flex;

    .btn-retour-erreur {
      margin: auto;
      background: transparent;
      border: none;
      cursor: pointer;

      i {
        color: $annexecolor;
      }
    }
  }

  .cas {
    width: 100%;
    min-height: 110px;
    margin-top: 2rem;
    color: $firstcolor;
    background-color: white;
    border: 1px solid $firstcolor;
    border-radius: 5px;
    text-align: center;
  }

  .cas:hover {
    text-decoration: none;
    background-color: $firstcolor !important;
    color: white;
  }
}

.div_loader {
  text-align: center;
  margin-top: 2rem;
}
</style>
